import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinwakad() {



    const cardData = {

keyword: "Cab Service in Wakad",

headingDescription:
    "Rising Cab Service offers reliable and affordable Cab Service in Wakad for daily commuters, families, IT professionals, and business travelers. We provide quick local rides, airport transfers, railway station drops, and comfortable outstation trips from Wakad to all major destinations. Our fleet includes well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by professional and verified chauffeurs. With 24/7 availability, on-time pickup, and transparent pricing, Rising Cab Service ensures a safe, smooth, and hassle-free travel experience in Wakad and nearby areas.",

topPlaces: [
   {
        title: "Lavasa",
        description:
            " is a planned hill city built with colorful, European-style architecture along a lakeside setting. It’s known for resorts, walking promenades, and adventure activities."
    },
     {
        title: "Lonavala",
        description:
            " is a popular hill station near Pune surrounded by lush valleys, waterfalls, and misty viewpoints. It’s especially famous during monsoon season and is a go-to weekend escape for trekking and relaxation."
    },
    {
        title: "Khandala",
        description:
            " lies close to Lonavala and is known for dramatic cliffs, fog-covered hills, and viewpoints like Tiger’s Leap. It’s a classic short trip destination from Pune and Mumbai."
    },
    {
        title: "Mahabaleshwar",
        description:
            " sits in the Western Ghats and is famous for its cool climate, strawberry farms, and scenic viewpoints. It offers boating, forest trails, and relaxing hill-station experiences."
    },
    
    {
        title: "Sinhagad Fort",
        description:
            " is a historic fort located on a hill near Pune. It’s popular for trekking and offers sweeping views of the Sahyadri range along with deep Maratha history."
    },
    {
        title: "Shaniwar Wada",
        description:
            " stands as a historic fort palace that once housed the Peshwas of the Maratha Empire. Its architecture and evening light show attract many visitors."
    },
    {
        title: "Aga Khan Palace",
        description:
            " is a landmark tied to India’s freedom struggle and is known for its elegant architecture and peaceful gardens."
    },
    {
        title: "Panchgani",
        description:
            " is a calm hill station near Mahabaleshwar famous for its table land plateau, strawberry farms, and panoramic valley views."
    },
    {
        title: "Mulshi Lake",
        description:
            " is a scenic reservoir surrounded by hills, often visited for picnics, sunset views, and nature stays in nearby resorts."
    },
    {
        title: "Rajgad Fort",
        description:
            " is a major Maratha fort and former capital of Shivaji Maharaj’s empire, known for its challenging trek and historic importance."
    }
],



services: [
    {
        name: "Cab Service in Wakad",
        description:
            "Rising Cab Service offers Cab Service in Wakad for daily commuters, families, corporate employees, and travelers looking for safe and reliable transportation. Our service ensures well-maintained AC cars, experienced drivers, doorstep pickup and drop, and 24x7 availability across Wakad and nearby Pune areas. We focus on providing smooth, comfortable, and affordable rides for both local and outstation travel with complete customer satisfaction."
    },
    {
        name: "Taxi Service in Wakad",
        description:
            "Our Taxi Service in Wakad provides convenient and hassle-free travel solutions for local and intercity routes. Rising Cab Service ensures timely pickups, professional chauffeurs, clean vehicles, and flexible booking options for office commute, airport transfers, and personal travel needs across Pune and Maharashtra."
    },
    {
        name: "Wakad Cab Service",
        description:
            "Rising Cab Service delivers reliable Wakad Cab Service for residents, IT professionals, and business travelers. We offer sedans, SUVs, and premium vehicles with safe driving, affordable pricing, and quick availability for all types of travel requirements."
    },
    {
        name: "Wakad Taxi Service",
        description:
            "Book Wakad Taxi Service with Rising Cab Service for comfortable and stress-free travel. Our taxis are ideal for daily commuting, shopping trips, airport transfers, and long-distance travel with experienced drivers ensuring a smooth journey."
    },
    {
        name: "Best Cab Service in Wakad",
        description:
            "Rising Cab Service provides the Best Cab Service in Wakad with high-quality vehicles, professional drivers, and transparent pricing. We ensure safe, reliable, and comfortable transportation for families, corporate clients, and individual travelers."
    },
    {
        name: "Online Cab Booking Wakad",
        description:
            "Our Online Cab Booking Wakad system allows quick and easy cab reservations with instant confirmation, multiple vehicle options, and transparent pricing. Rising Cab Service ensures a seamless booking experience for all travel needs."
    },
    {
        name: "Cab Hire in Wakad",
        description:
            "Rising Cab Service offers Cab Hire in Wakad for hourly rentals, full-day trips, corporate travel, and personal transportation. We provide flexible packages with professional drivers and well-maintained vehicles for maximum comfort."
    },
    {
        name: "Taxi Booking Wakad",
        description:
            "Book Taxi Booking Wakad with Rising Cab Service for fast and reliable transportation. We ensure timely service, clean vehicles, and affordable fares for both local and outstation travel requirements."
    },
    {
        name: "Outstation Cab Service Wakad",
        description:
            "Rising Cab Service provides Outstation Cab Service Wakad for long-distance travel to destinations like Mumbai, Shirdi, Nashik, Goa, Kolhapur, and Mahabaleshwar. We offer comfortable rides, experienced drivers, and flexible one-way or round-trip options."
    },
    {
        name: "Wakad to Mumbai Cab",
        description:
            "Book Wakad to Mumbai Cab with Rising Cab Service for safe and comfortable intercity travel. Our service ensures timely pickup, smooth highway driving, and reliable transportation for business and leisure trips."
    },
    {
        name: "Wakad to Shirdi Cab",
        description:
            "Rising Cab Service offers Wakad to Shirdi Cab for a peaceful pilgrimage journey to Sai Baba temple. Enjoy comfortable AC cars, professional drivers, and hassle-free travel experience."
    },
    {
        name: "Wakad to Nashik Cab",
        description:
            "Our Wakad to Nashik Cab service provides safe and reliable transportation for family trips, pilgrimages, and business travel with flexible booking options and experienced chauffeurs."
    },
    {
        name: "Wakad to Mahabaleshwar Cab",
        description:
            "Rising Cab Service offers Wakad to Mahabaleshwar Cab for a scenic hill station trip with comfortable vehicles and professional drivers ensuring a relaxing journey."
    },
    {
        name: "Wakad to Goa Cab",
        description:
            "Book Wakad to Goa Cab with Rising Cab Service for a smooth and enjoyable beach vacation trip with safe driving, clean vehicles, and flexible travel plans."
    },
    {
        name: "Wakad to Kolhapur Cab",
        description:
            "Rising Cab Service provides Wakad to Kolhapur Cab for pilgrimage and family travel with reliable drivers and comfortable intercity transportation."
    },
    {
        name: "Wakad to Lonavala Cab",
        description:
            "Our Wakad to Lonavala Cab service offers quick weekend getaway travel with safe, comfortable rides and experienced chauffeurs."
    },
    {
        name: "Wakad to Lavasa Cab",
        description:
            "Rising Cab Service provides Wakad to Lavasa Cab for scenic lake city trips with smooth travel experience and professional drivers."
    },
    {
        name: "Wakad to Bhimashankar Cab",
        description:
            "Book Wakad to Bhimashankar Cab for a spiritual Jyotirlinga pilgrimage with comfortable vehicles and reliable service from Rising Cab Service."
    },
    {
        name: "Innova Crysta on Rent in Wakad",
        description:
            "Rising Cab Service offers Innova Crysta on Rent in Wakad for premium comfort, spacious seating, and luxury travel experience ideal for families and groups."
    },
    {
        name: "Ertiga Cab Service Wakad",
        description:
            "Our Ertiga Cab Service Wakad provides affordable and comfortable family travel with clean vehicles and professional drivers for local and outstation trips."
    },
    {
        name: "Sedan Cab Service Wakad",
        description:
            "Rising Cab Service offers Sedan Cab Service Wakad for budget-friendly and comfortable travel ideal for daily commuting and short trips."
    },
    {
        name: "SUV Cab Service Wakad",
        description:
            "Book SUV Cab Service Wakad with Rising Cab Service for spacious and comfortable travel suitable for families, groups, and long-distance journeys."
    },
    {
        name: "Swift Dzire Cab Service Wakad",
        description:
            "Rising Cab Service provides Swift Dzire Cab Service Wakad for economical and comfortable rides perfect for city travel and short-distance trips."
    },
    {
        name: "Kia Carens Cab Service Wakad",
        description:
            "Our Kia Carens Cab Service Wakad offers modern, spacious, and comfortable travel for families and groups with professional drivers and safe journeys."
    },
    {
        name: "Innova Cab Service Wakad",
        description:
            "Rising Cab Service provides Innova Cab Service Wakad for group travel, airport transfers, and long-distance trips with maximum comfort and reliability."
    },
    {
        name: "Luxury Car Rental Wakad",
        description:
            "Book Luxury Car Rental Wakad with Rising Cab Service for premium vehicles, elegant travel experience, and professional chauffeur-driven service."
    },
    {
        name: "Car Rental with Driver Wakad",
        description:
            "Rising Cab Service offers Car Rental with Driver Wakad for safe, convenient, and flexible travel solutions across Pune and outstation destinations."
    },
    {
        name: "24 hour cab booking in Wakad",
        description:
            "Our 24 hour cab booking in Wakad ensures round-the-clock availability for local and outstation travel with quick response and reliable service."
    },
    {
        name: "Cab Service in Wakad Chowk",
        description:
            "Rising Cab Service provides Cab Service in Wakad Chowk with fast pickups, professional drivers, and comfortable vehicles for all travel needs."
    },
    {
        name: "Cab Service Near Wakad Bridge",
        description:
            "Book Cab Service Near Wakad Bridge for quick and convenient transportation with safe, reliable, and affordable travel options."
    },
    {
        name: "Taxi Service in Wakad Phase 1",
        description:
            "Rising Cab Service offers Taxi Service in Wakad Phase 1 for daily commuting, office travel, and local transportation with 24x7 availability."
    },
    {
        name: "Cab Service Near Hinjewadi Wakad",
        description:
            "Our Cab Service Near Hinjewadi Wakad ensures quick pickup for IT professionals and residents with reliable and comfortable travel options."
    },
    {
        name: "Taxi Service Near Balewadi High Street",
        description:
            "Rising Cab Service provides Taxi Service Near Balewadi High Street for shopping trips, nightlife travel, and daily commuting with safe and affordable rides."
    },
    {
        name: "Cab Service Near Bhumkar Chowk",
        description:
            "Book Cab Service Near Bhumkar Chowk with Rising Cab Service for fast and reliable transportation with experienced drivers and clean vehicles."
    }
],

tableData: [
    ["Cab Service in Wakad", "Taxi Service in Wakad"],
    ["Wakad Cab Service", "Wakad Taxi Service"],
    ["Best Cab Service in Wakad", "Online Cab Booking Wakad"],
    ["Cab Hire in Wakad", "Taxi Booking Wakad"],
    ["Outstation Cab Service Wakad", "Wakad to Mumbai Cab"],
    ["Wakad to Shirdi Cab", "Wakad to Nashik Cab"],
    ["Wakad to Mahabaleshwar Cab", "Wakad to Goa Cab"],
    ["Wakad to Kolhapur Cab", "Wakad to Lonavala Cab"],
    ["Wakad to Lavasa Cab", "Wakad to Bhimashankar Cab"],
    ["Innova Crysta on Rent in Wakad", "Ertiga Cab Service Wakad"],
    ["Sedan Cab Service Wakad", "SUV Cab Service Wakad"],
    ["Swift Dzire Cab Service Wakad", "Kia Carens Cab Service Wakad"],
    ["Innova Cab Service Wakad", "Luxury Car Rental Wakad"],
    ["Car Rental with Driver Wakad", "24 hour cab booking in Wakad"],
    ["Cab Service in Wakad Chowk", "Cab Service Near Wakad Bridge"],
    ["Taxi Service in Wakad Phase 1", "Cab Service Near Hinjewadi Wakad"],
    ["Taxi Service Near Balewadi High Street", "Cab Service Near Bhumkar Chowk"]
],





whychoose: [
    {
        WhyChooseheading: "Trusted Local Transportation in Wakad",
        WhyChoosedescription: "Rising Cab Service provides dependable cab solutions for residents, professionals, students, and visitors traveling within Wakad and nearby areas."
    },
    {
        WhyChooseheading: "Perfect for Daily Office Commutes",
        WhyChoosedescription: "Working professionals traveling to Hinjewadi IT Park, Baner, Balewadi, and surrounding business hubs can enjoy convenient and timely transportation."
    },
    {
        WhyChooseheading: "Suitable for Every Travel Requirement",
        WhyChoosedescription: "Whether it's local travel, airport transfers, railway station pickups, business meetings, shopping trips, or outstation journeys, we have the right vehicle for every need."
    },
    {
        WhyChooseheading: "Multiple Vehicle Categories Available",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on passenger count and travel preferences."
    },
    {
        WhyChooseheading: "Doorstep Pickup and Drop Facility",
        WhyChoosedescription: "Our cab service ensures convenient pickup and drop from residential societies, offices, hotels, hospitals, malls, and major landmarks in Wakad."
    },
    {
        WhyChooseheading: "Efficient Travel Planning Support",
        WhyChoosedescription: "From route suggestions to trip scheduling, our team assists customers in planning smooth and hassle-free journeys."
    },
    {
        WhyChooseheading: "Comfort-Focused Travel Experience",
        WhyChoosedescription: "Clean interiors, well-maintained vehicles, and courteous drivers contribute to a comfortable journey every time."
    },
    {
        WhyChooseheading: "Preferred by Families and Corporate Travelers",
        WhyChoosedescription: "Rising Cab Service serves families, IT professionals, business executives, tourists, and group travelers with equal dedication."
    }
]
};

const faqData = [
    {
        question: "What travel services are available from Wakad?",
        answer: "Customers can book local rides, airport transfers, railway station pickups, outstation cabs, corporate travel, and sightseeing trips."
    },
    {
        question: "Which nearby areas are covered by the service?",
        answer: "Our coverage includes Wakad, Hinjewadi, Baner, Balewadi, Tathawade, Pimple Saudagar, Ravet, Punawale, and surrounding locations."
    },
    {
        question: "Can office employees arrange regular transportation?",
        answer: "Yes, daily commuting solutions are available for professionals working in IT parks and commercial hubs."
    },
    {
        question: "Are airport transfers available at flexible timings?",
        answer: "Yes, airport pickup and drop services can be scheduled according to flight timings."
    },
    {
        question: "What vehicle types can be selected for travel?",
        answer: "We provide Sedan cars, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and larger vehicles for group transportation."
    },
    {
        question: "Is advance booking necessary for weekend travel?",
        answer: "Advance reservations are recommended during weekends, holidays, and peak travel seasons."
    },
    {
        question: "Can larger groups hire Tempo Travellers from Wakad?",
        answer: "Yes, group travel vehicles are available for family functions, corporate events, and sightseeing tours."
    },
    {
        question: "Are outstation trips available from Wakad?",
        answer: "Yes, cab services are available from Wakad to destinations across Maharashtra and neighboring states."
    },
    {
        question: "What makes this service suitable for families?",
        answer: "Spacious vehicles, professional drivers, and flexible travel options make it convenient for family journeys."
    },
    {
        question: "How can customers confirm a booking?",
        answer: "Bookings can be completed through a phone call, WhatsApp message, or online inquiry with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sanket Bhosale",
        feedback:
            "Regular airport travel from Wakad has become much easier since I started using Rising Cab Service. Timely arrivals and professional service have always impressed me.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Prajakta Shinde",
        feedback:
            "A recent family outing was handled exceptionally well. The vehicle was comfortable, the journey remained smooth, and the overall experience exceeded expectations.",
        rating: 5
    }
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Wakad",
"image": "https://www.risingcabservice.com/assets/images/cab-service-in-wakad.jpg",
"description": "Book Cab Service in Wakad with Rising Cab Service for local travel, airport transfers, and outstation trips. Enjoy safe, affordable, and reliable taxi service in Wakad with AC cars, SUVs, and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-service-in-wakad"
}
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Wakad | Local & Outstation Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Service in Wakad for local rides, airport transfers, and outstation travel. Affordable taxi service with AC cabs, SUVs like Innova Crysta, Ertiga, and professional drivers."
/>

<meta
 name="keywords"
 content="Cab Service in Wakad, Taxi Service in Wakad, Wakad Cab Service, Wakad Taxi Service, Best Cab Service in Wakad, Online Cab Booking Wakad, Cab Hire in Wakad, Taxi Booking Wakad, Outstation Cab Service Wakad, Wakad to Mumbai Cab, Wakad to Shirdi Cab, Wakad to Nashik Cab, Wakad to Mahabaleshwar Cab, Wakad to Goa Cab, Wakad to Kolhapur Cab, Wakad to Lonavala Cab, Wakad to Lavasa Cab, Wakad to Bhimashankar Cab, Innova Crysta on Rent in Wakad, Ertiga Cab Service Wakad, Sedan Cab Service Wakad, SUV Cab Service Wakad"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinwakad;